/**
 * Auth API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NevisAuthenticationRequest { 
    contractnumber: string;
    mode: NevisAuthenticationRequest.ModeEnum;
}
export namespace NevisAuthenticationRequest {
    export const ModeEnum = {
        APP: 'app',
        PUSH: 'push'
    } as const;
    export type ModeEnum = typeof ModeEnum[keyof typeof ModeEnum];
}


